import React, { useState, useEffect, memo } from "react";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid";
import { POST } from "../constant/RequestAuthService";
import { Stringify } from "../constant/Util";

const DatatablePaginate = ({ route, columns, refetch }) => {
  const [row, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [counts, setCounts] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [orderValue, setOrderValue] = useState({});
  const [searchCount, setSearchCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  };

  const getResponse = async (
    page = 1,
    limit = 10,
    search = "",
    orderBy = ""
  ) => {
    setIsLoading(true);
    const { status, data } = await POST(`${route}?page=${page}`, {
      limit: limit,
      order_by: orderBy,
      search: search,
    });
    if (status === 200) {
      console.log(data);
      setCounts(data.total);
      setRows(data.data);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const pageNumber = sessionStorage.getItem("page");
    const limit = sessionStorage.getItem("limit");
    const search = sessionStorage.getItem("search");
    const order = sessionStorage.getItem("order");

    if (
      pageNumber &&
      pageNumber !== undefined &&
      pageNumber !== "null" &&
      pageNumber !== ""
    ) {
      setPage(+pageNumber);
    } else {
      sessionStorage.setItem("page", 1);
      setPage(1);
    }

    if (limit && limit !== undefined && limit !== "null" && limit !== "") {
      setPerPage(+limit);
    } else {
      sessionStorage.setItem("limit", 10);
      setPerPage(10);
    }

    if (order && order !== undefined && order !== "null" && order !== "") {
      setOrderValue(order);
    } else {
      sessionStorage.setItem("order", Stringify({}));
      setOrderValue({});
    }

    if (
      search &&
      search !== undefined &&
      search !== "null" &&
      search !== "" &&
      search.length > 2
    ) {
      setSearchValue(search);
    } else {
      sessionStorage.setItem("search", "");
      setSearchValue("");
    }

    getResponse(pageNumber, limit, search, order);
    // eslint-disable-next-line
  }, [refetch]);

  // useEffect(() => {
  //   getResponse();
  //   // eslint-disable-next-line
  // }, []);

  const handlePageChage = (value) => {
    setPage(value);
    getResponse(value, perPage, searchValue, orderValue);
    sessionStorage.setItem("page", value);
  };

  const handlePerPageChage = (value) => {
    setPage(1);
    setPerPage(value);
    getResponse(1, value, searchValue, orderValue);
    sessionStorage.setItem("page", 1);
    sessionStorage.setItem("limit", value);
  };

  const handleSortingChange = (value) => {
    setPage(1);
    const orderData = { ...value[0] };
    setOrderValue(orderData);
    getResponse(1, perPage, searchValue, orderData);
    sessionStorage.setItem("page", 1);
    sessionStorage.setItem("order", Stringify(orderData));
  };

  useEffect(() => {
    const getData = setTimeout(() => {
      if (searchValue.length > 2) {
        getResponse(page, perPage, searchValue, orderValue);
        setSearchCount(searchValue.length);
        sessionStorage.setItem("search", searchValue);
      }
    }, 300);

    return () => clearTimeout(getData);
    // eslint-disable-next-line
  }, [searchValue]);

  const handleSearch = (value) => {
    setPage(1);
    const searchLength = value.length || "";
    if (searchLength > 2) {
      setSearchValue(value);
    } else if (searchLength <= 2 && searchCount > searchLength) {
      getResponse(1, perPage, "", orderValue);
      setSearchValue("");
      setSearchCount(0);
      sessionStorage.setItem("page", 1);
      sessionStorage.setItem("search", "");
    }
  };

  return (
    <>
      <div className="row" style={{ marginBottom: "20px" }}>
        <div className="col-12">
          <div className="form form-group d-flex justify-content-end align-items-center">
            <label>Search : &nbsp;</label>
            <input
              type="text"
              className="form-control mt-2"
              name="search"
              required
              style={{ width: "200px" }}
              onChange={(e) => handleSearch(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div style={{ width: "100%" }}>
        <DataGrid
          key={row.id ? row.id : 1}
          rows={row}
          columns={columns}
          pageSize={perPage}
          autoHeight
          onPageSizeChange={(newPageSize) => handlePerPageChage(newPageSize)}
          rowsPerPageOptions={[10, 20, 50, 100]}
          pagination
          checkboxSelection={false}
          loading={isLoading}
          components={{
            Toolbar: CustomToolbar,
          }}
          paginationMode="server"
          page={page - 1}
          rowCount={counts}
          onPageChange={(page) => handlePageChage(page + 1)}
          onSortModelChange={(column) => handleSortingChange(column)}
        />
      </div>
    </>
  );
};

export default memo(DatatablePaginate);
